import * as InternalUtils from "scriptsShared/Utils.js";
import FileInputFormVue from "./FileInputForm.vue";
export default {
  name: "v-file-input-form-validated",
  data: function data() {
    return {
      valueInternal: this.value
    };
  },
  computed: {
    nameInternal: function nameInternal() {
      if (this.name) return this.name;else return this.label.toLowerCase();
    },
    requiredRule: function requiredRule() {
      if (!!this.rules === false) return false;
      if (typeof this.rules === "string") {
        return this.rules.includes("required");
      } else {
        return !!this.rules.required;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.$refs.provider && typeof _this.$refs.provider.validate === 'function') {
        _this.$refs.provider.validate().catch(function (err) {
          console.error('Validation error on mount:', err);
        });
      }
    });
    InternalUtils.AssignReactivePropWatches(this);
  },
  watch: {
    valueInternal: function valueInternal(newVal) {
      var _this2 = this;
      this.$nextTick(function () {
        if (_this2.$refs.provider && typeof _this2.$refs.provider.validate === 'function') {
          _this2.$refs.provider.validate().catch(function (err) {
            console.error('Validation error in watcher:', err);
          });
        }
      });
    }
  },
  props: {
    value: {
      required: true,
      reactive: true
    },
    inputId: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    name: String,
    // Captures the parent's `data-cy` attribute (ValidationProvider drops fallthrough attrs) and forwards it to the input.
    dataCy: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Object],
      required: true
    },
    accept: String,
    description: String,
    validateOnMount: Boolean
  },
  components: {
    "v-file-input-form": FileInputFormVue
  }
  //   watch: {
  //     valueInternal() {
  //       this.$emit("input");
  //     },
  //   },
};